/**
 * 결제 로직
 * @param {array} array 0 : 로직종류, 1~ : array - 파라미터 배열
 */
function payment_logic(array){
    var param = array.split("&");
    switch(param[0]){
        case "0" :
            inputCash(param[1]);
            break;
        case "1":
            completeRelease(param[1]);
            break;
        case "2":
            completeCard(param);
            break;
        case "3":
            receiptCash(param);
            break;
        case "4":
            completeCardCancel(param[1]);
    }
}

let g_payment_total_pay = 0;    // 결제금액
let g_input_pay = 0;            // 입금금액
let g_cash_receipt_yn = '';     // 현금영수증 여부
let g_cash_receipt_kind = 0;    // 현금영수증 종류 0: 개인, 1: 법인
let g_card_div = 0;             // 카드결제 할부개월
let g_callback;                 // 콜백(command, message)
let g_history_id;               // 결제 아이디
let g_goods_type_code;          // 결제 상품 종류
let g_user_hp;                  // 결제자 휴대폰


/**
 * 현금 결제 요청
 * @param {Number} total_pay - 결제금액
 * @param {*} cash_receipt_yn - 현금영수증 여부
 * @param {*} cash_receipt_kind - 현금영수증 종류 0: 개인, 1: 법인
 * @param {*} receipt_info - 영수증 정보
 * @param {*} callback - 콜백
 */
function paymentByCash(total_pay, cash_receipt_yn, cash_receipt_kind, callback){
    total_pay = removeWithCommas(total_pay)*1;
    g_payment_total_pay = total_pay;
    g_cash_receipt_yn = cash_receipt_yn;
    g_cash_receipt_kind = cash_receipt_kind;
    g_callback = callback;
    cashBoard.billOn();
}
//---------------------------- 현금 로직 ----------------------------//
var g_timeoutID = null;
/**
 * C# -> 웹 (현금 입수시 처리)
 * @param {*} cash - 현금 입금 금액
 */
function inputCash(cash){	// C# -> 웹 (현금 입수시 처리)
    g_input_pay = cash*1;

    g_callback('cashMessage', g_input_pay);

    if( g_input_pay >= g_payment_total_pay ){
        cashBoard.billOff();

        g_callback('cashComplete', '거스름돈이 나오는 중입니다.');

        g_timeoutID = setTimeout(function(){ completeCash(g_input_pay, g_payment_total_pay);}, 1000);
    }
}

function completeCash(input, total){
    if( g_timeoutID != null ) clearTimeout(g_timeoutID);

    if( g_cash_receipt_yn){
        vcat.cashReceipt(g_payment_total_pay, g_cash_receipt_kind, 999);
    }else{
        releaseCash(input,total);
    }
}
function receiptCash(array){
    if(!array[3]){
        cashReceiptFailed(array[1]);
    }else{
        g_callback('cashReceiptSuccess', array);
        releaseCash(g_input_pay, g_payment_total_pay);
    }
}

function cashReceiptFailed(msg){
    if(msg == "사용자취소"){
        var error_obj = new Object();
        error_obj.message = '현금영수증을 취소하셨습니다. 이대로 결제를 진행하시겠습니까?';
        g_callback('cashReceiptError', error_obj);
    }else{
        var error_obj = new Object();
        error_obj.message = '사유 : ' + msg + '<br> 현금영수증을 다시 시도하시겠습니까?';
        g_callback('cashReceiptError', error_obj);

    }
}

// 현금영수증 실패시 기존 정보로 재시도
function paymentByReceiptRetry(){
    vcat.cashReceipt(g_payment_total_pay, g_cash_receipt_kind, 999);
}
// 현금영수증 취소시 다음스텝 진행
function receiptCancelNext(){
    releaseCash(g_input_pay, g_payment_total_pay);
}

function releaseCash(input,total){
    if(input != total){
        cashBoard.releaseCash(input - total);
    }else if(input == total){
        g_callback('cashSuccess', '');
    }
}

function completeRelease(outputCount){// C# -> 웹 (거스름돈 방출 후 진입 outputCount : 실제 방출된 금액)
    var total_output_pay = g_input_pay - g_payment_total_pay;   // 방출되어야할 금액

    var out_pay = Math.abs(total_output_pay - outputCount*1);	// 미방출된 금액
    var delay_count = 0;

    if(out_pay != 0){
        var error_obj = new Object();
        error_obj.message = `시재금이 부족하여 ${numberWithCommas(out_pay*1)} 원이\n 미방출 되었습니다.\n 관리자에게 문의해주시기 바랍니다.`;
        error_obj.error_cash = (out_pay);
        error_obj.input_cash = g_input_pay;
        error_obj.output_cash = outputCount;
        g_callback('cashError', error_obj);
        delay_count = 5000;
    }else{
        delay_count = 1000;
    }
    setTimeout(function(){
        g_callback('cashSuccess', '');
    }, delay_count);
}
function total_pay_set(total_pay){
    g_payment_total_pay = total_pay;
}


//---------------------------- 카드 로직 ----------------------------//
function paymentByCard(total_pay, div_month, callback){
    g_payment_total_pay = removeWithCommas(total_pay)*1;
    g_card_div = div_month;
    g_callback = callback;

    vcat.singlePay(g_payment_total_pay, g_card_div, 999);
}
// 결재 실패시 기존 정보로 결제 재시도
function paymentByCardRetry(){
    vcat.singlePay(g_payment_total_pay, g_card_div, 999);
}

// 0 : 로직종류(사용x)
// 1 : 결과메세지
// 2 : 카드번호
// 3 : 할부개월
// 4 : 승인번호
// 5 : 카드이름
function completeCard(array){ //C# -> 웹
    if( g_timeoutID != null ) clearTimeout(g_timeoutID);

    if (!array[4]) {
        cardFailed(array[1]);
    }else{
        g_callback('cardSuccess', array);
    }
}

function cardFailed(msg){
    var error_obj = new Object();
    if(msg == "사용자취소"){
        error_obj.message = "cancel";
        g_callback('cardError', error_obj);
    }else if(msg != "정상"){
        error_obj.message = '사유 : ' + msg + '<br> 결제를 다시 시도하시겠습니까?';
        g_callback('cardError', error_obj);
    }
}

function cardProcessCancel(){
    vcat.payReturn();
}


// QR 바코드 결제
function paymentByBarcode(total_pay, callback){
	payInit();
    g_payment_total_pay = removeWithCommas(total_pay)*1;
    g_payment_tax_pay = 0;
    //g_card_div = div_month;
    g_callback = callback;
	g_pay_type = 'barcode';
	if(g_payment_tax_pay == 0) { // 과세만 결제하는 경우
		vcat.barcodePay(g_payment_total_pay, "00", "PRO", g_payment_tax_pay);
	} else if(g_payment_total_pay == g_payment_tax_pay) { //비과세만 결제 하는 경우
		vcat.barcodePay(g_payment_total_pay, "00", "PRO", g_payment_tax_pay);
	} else { //과세와 비과세 둘다 결제인 경우에는 과세부터 처리하고 나서 비과세를 처리한다.
		g_both_payment = 1; // 혼합결제 플래그
		g_payment_first_pay = g_payment_total_pay - g_payment_tax_pay; // 토탈에서 면세금액을 뺀금액이 과세금액
		g_payment_second_pay = g_payment_tax_pay; // 면세금액이 곧 비과세 적용 금액
		vcat.barcodePay(g_payment_first_pay, "00", "PRO", 0);

	}
    
}

function cancelPaymentByBarcode(data, history_id, callback){
	g_action = 'cancel';
	g_callback = callback;
	g_history_id = history_id;
	if(data.catid != undefined && data.catid != ''){
		vcat.barcodeCancel(removeWithCommas(data.payment_amount), data.card_div, 'PRO', data.approval_number, data.payment_datetime.replace(/-/g,'').substr(0,6), `${data.catid}`);
		//vcat.barcodeCancel(removeWithCommas(data.payment_amount), data.card_div, 'PRO', data.approval_number, data.payment_datetime.replace(/-/g,'').substr(0,6));
	}else {
		vcat.barcodeCancel(removeWithCommas(data.payment_amount), data.card_div, 'PRO', data.approval_number, data.payment_datetime.replace(/-/g,'').substr(0,6));
	}
	
}


/**
 * 카드 결제 취소
 */
function cancelPaymentByCard(data, history_id, goods_type_code, user_hp, callback){

    g_callback = callback;
    g_history_id = history_id;
    g_goods_type_code = goods_type_code;
    g_user_hp = user_hp;
    vcat.singlePayCancel(removeWithCommas(data.payment_amount), data.card_div, 120, data.approval_number, data.payment_datetime.replace(/-/g,'').substr(0,8));
}
function completeCardCancel(msg){
    g_callback(msg, g_history_id, g_goods_type_code, g_user_hp);
}

function printReceipt(storeInfo, paymentInfo){
    storeInfo = vueObjectToJSON(storeInfo);
    paymentInfo = vueObjectToJSON(paymentInfo);


    cFunction.printReceipt(storeInfo, paymentInfo);
}

function barcode_print(userHp, endDate, storeName, corpNo, storeAdd, adminName, storeCD, title, arrayString){
    if (typeof window.external.printReceipt === "function") {
        window.external.printReceipt("", userHp, "", "", endDate, "", "0", "",storeName,corpNo,storeAdd,adminName,storeCD,title,arrayString,"","");
    }
}

function vueObjectToJSON(param){
    let array = {};
    for(var key in param){
        array[key] = param[key];
    }
    return array;
}

// 단위 붙이기
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
// 단위 제거
function removeWithCommas(x) {
    return x.toString().replace(/,/g,"");
}


//---------------------------- 키오스크 UI 호출 ----------------------------//
export default {
    paymentByCash : paymentByCash,
    paymentByCard : paymentByCard,
    cancelPaymentByCard : cancelPaymentByCard,
    barcode_print : barcode_print,
    printReceipt : printReceipt,
    payment_logic : payment_logic,
    total_pay_set : total_pay_set,
    paymentByCardRetry : paymentByCardRetry,
    cardProcessCancel : cardProcessCancel,
    paymentByReceiptRetry : paymentByReceiptRetry,
    receiptCancelNext : receiptCancelNext,
}



// WEBPACK FOOTER //
// ./src/assets/js/external.js